import { render, staticRenderFns } from "./clashList.vue?vue&type=template&id=6b6094b6&scoped=true"
import script from "./clashList.vue?vue&type=script&lang=js"
export * from "./clashList.vue?vue&type=script&lang=js"
import style0 from "./clashList.vue?vue&type=style&index=0&id=6b6094b6&prod&lang=scss"
import style1 from "./clashList.vue?vue&type=style&index=1&id=6b6094b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6094b6",
  null
  
)

export default component.exports